import React, { useState } from "react";
import axios from "axios";
import "./Weather.css";
import WeatherInfo from "./WeatherInfo";
import Forecast from "./Forecast";

export default function Weather(props) {
  let [city, setCity] = useState(props.defaultCity);
  let [weather, setWeather] = useState({ready:false});

  function showDetail(response) {
    console.log(response.data); // Log the API response data
    setWeather({
      ready:true,
      city: response.data.city,
      coordinates: response.data.coordinates,
      temperature: Math.round(response.data.temperature.current),
      description: response.data.condition.description,
      humidity: response.data.temperature.humidity,
      wind: response.data.wind.speed,
      icon: response.data.condition.icon_url,
      country: response.data.country,
      date: new Date(response.data.time *1000),
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function updateCity(event) {
    setCity(event.target.value);
  }

  function search() {
    let url = `https://api.shecodes.io/weather/v1/current?query=${city}&key=482baea94563a32ca5b7f5ab8bto730f&units=metric`;
    axios.get(url).then(showDetail);
  }

  if (weather.ready) {
    return (
      <div className="Weather">
        <div className="SearchContainer">
        <form onSubmit={handleSubmit}>
          <input
            className="SearchBox"
            type="search"
            placeholder="Enter a city"
            onChange={updateCity}
          />
          <input className="Button" type="submit" value="Search" />
        </form>
        
        </div>
      
        <WeatherInfo data={weather}/>
        <footer>
        <Forecast coordinates={weather.coordinates} />
      <p>This was coded by Shirley and is an open-source code on <a href="https://github.com/shirleyyyy1405/react-weather-app">Github</a></p>
      </footer>
    </div>
  
  );
  } else {
    search();
    return "Loading...";
  }

 
}

